<template>
  <v-container fluid class="mt-0 pt-0" v-if="shuttleLoaded">




  <v-row no-gutters>





  <v-divider></v-divider>



              <!-- :vertical="$vuetify.breakpoint.mdAndUp && !this.$store.state.drawer && active_tab != 'entities_tab'" -->

                <!--//
                    VIDEO
                    :order="$vuetify.breakpoint.mdAndUp ? 'last' : 'first'"
                //-->

                <!--//

                  VIDEO and HELP container.
                  keep video on top for all editing options
                  help should change with tabs.
                  if no video, then allow upload of video.
                //-->

                <v-col class="pr-1" :md="orderSettings.videoPanel.sz" sm="12" xs="12" :order="orderSettings.videoPanel.order">

                    <ShuttleVideo v-if="shuttleLoaded" @uploaded="newVideoUploaded()" />



                    <ShuttleHelp :help="help" />

                </v-col>



<!---//

DEBUG TAB
:md="active_tab == 'entities_tab' ? 12 : 4" :order="$vuetify.breakpoint.mdAndUp ? '' : 'last'">
//-->
<v-col md="12" v-if="nav_top">



  <v-tabs
    centered
    color="primary" show-arrows v-model="active_tab">

  <v-tab href="#video_tab">
    <v-icon left>mdi-video-outline</v-icon>
    Settings
  </v-tab>



  <v-tab href="#transcript_tab">
    <v-icon left>mdi-tooltip-text-outline</v-icon>
    Transcript
  </v-tab>

  <v-tab  href="#presenter_tab">
    <v-icon left>mdi-account</v-icon>
    Presenters
  </v-tab>



  <!--//
  <v-tab>
    <v-icon left>mdi-comment-question-outline</v-icon>
    Questions
  </v-tab>
  //-->


  <v-tab  href="#bookmark_tab">
    <v-icon left>mdi-bookmark-multiple-outline</v-icon>
    Bookmarks
  </v-tab>




  <v-tab  href="#text_tab">
    <v-icon left>mdi-text-recognition</v-icon>
    Text
  </v-tab>




  <v-tab  href="#quiz_tab">
    <v-icon left>mdi-crosshairs-question</v-icon>
   Quizzes
  </v-tab>



  <v-tab  href="#entities_tab" v-if="hide_tab">
    <v-icon left>mdi-text-recognition</v-icon>
    Key Points
  </v-tab>






  <v-tab href="#options_tab">
    <v-icon left>mdi-cogs</v-icon>
    LMS Settings
  </v-tab>


  <v-tab href="#debug_tab">
    <v-icon left>mdi-android-debug-bridge</v-icon>
    DEBUG
  </v-tab>
  </v-tabs>



</v-col>
<v-col
  :order="orderSettings.formPanel.order"
  :md="orderSettings.formPanel.sz"
  sm="12"
  xs="12"
>
<!-- removed v-if="!upload_new" -->
<v-card tile class="elevation-4">

  <v-breadcrumbs :items="crumbs">

    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        @click="crumbRoute(item.route === null || item.disabled ? null : item.route)"
        :disabled="item.disabled"

      >
        <a v-if="!item.disabled">{{ item.text }}</a>
        <span v-else>{{ item.text }}</span>
      </v-breadcrumbs-item>

    </template>

    <template v-slot:divider>
      <v-icon>mdi-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>


  <v-toolbar extended flat>


    <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn

                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="(opt, i) in viewOpts"
                      :key="i"
                      @click="applyOrder(opt.title)"
                    >
                      <v-list-item-title>{{ opt.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
<v-toolbar-title>Editor</v-toolbar-title>



            <v-spacer></v-spacer>

            <v-btn small class="mr-4" color="red" outlined @click="showArchiveShuttle()" >
              <v-icon left>mdi-package-down</v-icon> ARCHIVE
            </v-btn>


            <v-btn small outlined color="blue" class="mr-4"
              @click="previewShuttle($store.state.currentShuttle.id)"
            >
              Preview
            </v-btn>

            <!-- <v-btn small class="mr-4" color="yellow" @click="packageContent()" :loading="editor_overlay">
              <v-icon left>mdi-package-variant-closed</v-icon> Package
            </v-btn> -->

            <v-btn v-show="this.$store.state.currentShuttle.package && this.$store.state.currentShuttle.packageready" class="ma-2" tile outlined small @click="downloadShuttle()">
              <v-icon left>mdi-download</v-icon> Download
            </v-btn>

            <v-btn small class="mr-4" color="primary" @click="saveChanges()">
              Save
            </v-btn>









<template v-slot:extension >
<v-tabs
  centered
  color="primary" show-arrows v-model="active_tab">

<v-tab href="#video_tab">
  <v-icon left>mdi-video-outline</v-icon>
  Settings
</v-tab>



<v-tab href="#transcript_tab">
  <v-icon left>mdi-tooltip-text-outline</v-icon>
  Transcript
</v-tab>

<v-tab  href="#presenter_tab">
  <v-icon left>mdi-account</v-icon>
  Presenters
</v-tab>



<!--//
<v-tab>
  <v-icon left>mdi-comment-question-outline</v-icon>
  Questions
</v-tab>
//-->


<v-tab  href="#bookmark_tab">
  <v-icon left>mdi-bookmark-multiple-outline</v-icon>
  Bookmarks
</v-tab>




<v-tab  href="#text_tab">
  <v-icon left>mdi-text-recognition</v-icon>
  Text
</v-tab>




<v-tab  href="#quiz_tab">
  <v-icon left>mdi-crosshairs-question</v-icon>
 Quizzes
</v-tab>



<v-tab  href="#entities_tab" v-if="hide_tab">
  <v-icon left>mdi-text-recognition</v-icon>
    Key Points
</v-tab>






<v-tab href="#options_tab">
  <v-icon left>mdi-cogs</v-icon>
  LMS Settings
</v-tab>


<v-tab href="#debug_tab">
  <v-icon left>mdi-android-debug-bridge</v-icon>
  DEBUG
</v-tab>
</v-tabs>
</template>



  </v-toolbar>





<v-tabs-items v-model="active_tab">
<v-tab-item value="debug_tab" :eager="true">
   <v-container>
                          <v-card flat >
                            <pre><code>
  {{JSON.stringify(this.$store.state.currentShuttle, undefined, 10)}}
</code>
</pre>
</v-card></v-container>
</v-tab-item>

<!---//

VIDEO TAB

//-->

                      <v-tab-item value="video_tab" :eager="true" >
                          <ShuttleVideoOptions ref="editorVideoOptions" :tabupdate="options_tab_switch"/>

                      </v-tab-item>






<!---//

transcript TAB

//-->

                        <v-tab-item value="transcript_tab" :eager="true" >
                           <ShuttleTranscript ref="editorTranscript" :tabupdate="transcript_tab_switch"/>

                        </v-tab-item>




<!---//

presenter TAB

//-->

                        <v-tab-item value="presenter_tab" :eager="true" >
                           <ShuttlePresenters :tabupdate="presenter_tab_switch"/>

                        </v-tab-item>




<!---//

bookmark TAB

//-->

                        <v-tab-item value="bookmark_tab" :eager="true" >
                           <ShuttleVideoBookmarks :tabupdate="bookmark_tab_switch"/>

                        </v-tab-item>

<!---//

Options TAB

//-->

                        <v-tab-item value="options_tab" :eager="true" >
                           <ShuttleOptions :tabupdate="lms_options_tab_switch"/>

                        </v-tab-item>


<!---//

Text Interactions

//-->

                        <v-tab-item value="text_tab"  >
                           <ShuttleTextInteractions :tabupdate="text_tab_switch"/>

                        </v-tab-item>
                        <v-tab-item value="entities_tab">
                           <ShuttleNamedEntities2 />

                        </v-tab-item>



<!---//
Quizzes

//-->

                        <v-tab-item value="quiz_tab"  >
                           <ShuttleQuizInteractions :tabupdate="quiz_tab_switch"/>

                        </v-tab-item>




                      </v-tabs-items>


                    </v-card>
                      </v-col>





            </v-row>




    <v-dialog
      v-model="archive_shuttle"
      width="500"
    >

   <v-card>
        <v-card-title class="headline grey lighten-2">
         Archive Shuttle
        </v-card-title>


      <v-card-text>
          Archiving this shuttle will remove it from your active list of shuttles to EDIT. Any references to this shuttle in other platforms such as Simpatico or your LMS will still be active. You will need to access those systems and remove references to this shuttle if your goal is to prevent access to this content.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

            <v-btn small class="mr-4" color="red" outlined @click="archiveShuttle()" >
              <v-icon left>mdi-package-down</v-icon> OK, ARCHIVE THIS SHUTTLE!
            </v-btn>

          <v-btn
            color="primary"
            text
            @click="archive_shuttle = false"
          >
            CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
   


  </v-dialog>



      </v-container>






</template>





<!--

//-->


<script>

  import { v4 as uuidv4 } from 'uuid';
  import ShuttleMixins from '@/mixins/ShuttleMixins.js';

export default {
  name: 'ShuttleEdit',
    mixins:[ShuttleMixins],
    components: {

   ShuttleHelp: () => import('./ShuttleHelp.vue'),
   ShuttleVideo: () => import('./ShuttleVideo.vue'),
   ShuttleVideoOptions: () => import('./ShuttleVideoOptions.vue'),
   ShuttleTranscript: () => import('./ShuttleTranscript.vue'),
   ShuttlePresenters: () => import('./ShuttlePresenters.vue'),
   ShuttleVideoBookmarks: () => import('./ShuttleVideoBookmarks.vue'),
   ShuttleOptions: () => import('./ShuttleOptions.vue'),
   ShuttleTextInteractions:() => import('./ShuttleTextInteractions.vue'),
   ShuttleNamedEntities2:() => import('./ShuttleNamedEntities2.vue'),
   ShuttleQuizInteractions:() => import('./ShuttleQuizInteractions.vue')

  },
  data() {
    return {
      shuttleLoaded:false,
      editor_saving: false,
      editor_overlay: false,
      nav_top: false,
      orderSettings: {
        formPanel: { order: 2, sz: 6 },
        videoPanel: { order: 1, sz: 6 }
      },
      viewOpts: [
        {title:'left'},
        {title:'right'},
        {title:'nav full'},
        {title:'nav short'}
        //{title:'bottom'}
      ],
      hide_tab: true,

        currentshuttle:{},

        current_h5p_content:{},


        active_tab:'video_options',

        editable_set:false,
        componentKey:0,


        help:'video_upload',


        transcript_tab_switch:0,
        options_tab_switch:0,
        presenter_tab_switch:0,
        video_tab_switch:0,
        bookmark_tab_switch:0,
        lms_options_tab_switch:0,
        text_tab_switch:0,
        quiz_tab_switch:0,

        loaded: false,

        upload_new: false,
        archive_shuttle:false



    }
  },

  watch:{





      active_tab: async function(){

            this.$store.commit('H5P', {isDomReady:false,isVideoReady:false});
            this.$store.commit('currentEditTab',this.active_tab);
             //console.log('edit active tab set to: ' + this.$store.state.currentEditTab);
            switch(this.active_tab){

                case 'video_tab':
                      this.options_tab_switch = this.options_tab_switch + 1;

                    break;

               case 'transcript_tab':
                      this.transcript_tab_switch = this.transcript_tab_switch + 1;
                  break;

               case 'presenter_tab':
                      this.presenter_tab_switch = this.presenter_tab_switch + 1;

                      this.$store.commit('help', 'presenter_info');
                  break;

                case 'bookmark_tab':
                      this.bookmark_tab_switch = this.bookmark_tab_switch + 1;

                      this.$store.commit('help', 'video_bookmarks');
                  break;

                 case 'options_tab':
                      this.lms_options_tab_switch = this.lms_options_tab_switch + 1;

                      this.$store.commit('help', 'lms_options');
                  break;

                  case 'quiz_tab':
                      this.quiz_tab_switch = this.quiz_tab_switch + 1;
                  break;

                 case 'text_tab':
                      this.text_tab_switch = this.text_tab_switch + 1;
                  break;

                  case 'video_options':
                    this.$store.commit('help', 'video_options');
                  break;



            }

      }

  },


  methods: {


    showArchiveShuttle(){

        this.archive_shuttle = true;

    },
    


    async archiveShuttle(){

         this.$store.commit('currentShuttleArchive', true);
         var x = await this.saveShuttle();
         this.$router.push({path:'/studio/list/' + this.$store.state.dynamo.customer_id});



    },
   


    async downloadShuttle(){

        var downlodpath = this.$store.state.uri.app_base_uri + '/uploads/' + this.$store.state.currentShuttle.customer_id + '/shuttles/' + this.$store.state.currentShuttle.id + '/package/' + this.$store.state.currentShuttle.package;

        //console.log(downlodpath);
       document.location.href = downlodpath;

    },

    applyOrder(neworder) {
      if (neworder == 'left') {
        this.orderSettings.formPanel.order = 1;
        this.orderSettings.videoPanel.order = 2;
        this.orderSettings.formPanel.sz = 6;
        this.orderSettings.videoPanel.sz = 6;
      } else if (neworder == 'right') {
        this.orderSettings.formPanel.order = 2;
        this.orderSettings.videoPanel.order = 1;
        this.orderSettings.formPanel.sz = 6;
        this.orderSettings.videoPanel.sz = 6;
      } else if (neworder == 'bottom') {
        this.orderSettings.formPanel.order = 2;
        this.orderSettings.videoPanel.order = 1;
        this.orderSettings.formPanel.sz = 12;
        this.orderSettings.videoPanel.sz = 6;
      } else if (neworder == 'nav full') {
        this.nav_top = true;
      } else if (neworder == 'nav short') {
        this.nav_top = false;
      }

      this.$store.commit('setEditorLayout', neworder);
    },


    saveChanges() {
      switch (this.active_tab) {
        case 'video_tab':
          this.$refs.editorVideoOptions.saveVideoOptions();
        break;
        case 'transcript_tab':
          this.$refs.editorTranscript.saveUserTranscript();
        break;
        case 'quiz_tab':
          this.saveShuttle();
        break;        
        case 'bookmark_tab':
          this.saveShuttle();
        break;
        case 'presenter_tab':
          this.saveShuttle();
        break;
        case 'text_tab':
          this.saveShuttle();
        break;
        case 'entities_tab':
          this.saveShuttle();
        break;
        case 'options_tab':
          this.saveShuttle();
        break;
        case 'debug_tab':
          //this.saveShuttle();
        break;

        case 'text_tab':
          this.saveShuttle();
        break;
      }
    },



    // async packageContent() {
    //   this.$refs.editorVideoOptions.packageShuttle();

    //          this.editor_overlay = true;
    //          this.$store.commit('overlayLoadingState', 'Please Stand By');
    //          var packageh5p =  await this.generateDynamicH5p(false,'h5p');




    //          this.$store.commit('packageready', false);
    //          let path  = this.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub + '/shuttle/package';
    //          let postdata = this.$store.state.currentShuttle;
    //          postdata.H5PContent = packageh5p;

    //          //update here for h5p vs simpatico
 


    //          let packageresponse = await this.getData( path,'post',postdata);
    //          this.editor_overlay = false;
    //          this.$store.commit('removeOverlay');
    //          //console.log(packageresponse)
    //          if(packageresponse.success){
    //           this.$store.commit('currentShuttlePackage', packageresponse.package);
    //           this.$store.commit('packageready', true);
    //           this.downloadShuttle();
    //         }

    // },



    async newVideoUploaded() {
      this.upload_new = false;
      //this.createNewShuttle(this.$route.params.id);
      let postshuttle = {};
      postshuttle.shuttle = this.dynamoMarshall(this.$store.state.currentShuttle);

     //let path  = this.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub + '/shuttle/create';
     //let shuttleresponse = await this.getData( path,'post',postshuttle);

     this.$store.commit('dynamo', await this.getUserShuttles());


     let myshuttles = Object.assign([],this.$store.state.dynamo.shuttles);

     if(!myshuttles){
         myshuttles = [];
     } else {
       this.$store.commit('currentShuttleCreationDate', new Date().toISOString());



     }
    },


      async checkShuttles(shuttleid, shuttleLoaded) {

          var has_shuttles = false;
          var existing_shuttle = false;
          this.$store.commit('dynamo', await this.getUserShuttles());
          let myshuttles =  Object.assign([],this.$store.state.dynamo.shuttles);

          

          //clear out the current shuttle 
          //await this.$store.dispatch('currentShuttle', {});


          var x =  await this.$store.dispatch('currentShuttle', {}); 

          //console.log('verify current shuttle cleared')
          //console.log(this.$store.state.currentShuttle)


          if(myshuttles){


            has_shuttles = true;
            let currentShuttle = myshuttles.find(({id}) => id == shuttleid);

              if(currentShuttle){
                  existing_shuttle = true;


                   await this.$store.dispatch('currentShuttle', currentShuttle); 


                  this.active_tab = 'video_tab';
              }
          }


          if (!existing_shuttle){
            this.upload_new = true;
            //console.log('CREATE NEW SHUTTLE: ' + shuttleid);

              var newshuttle = {
                  customer_id:this.$store.state.dynamo.customer_id,
                  id:shuttleid,
                  title:'New Shuttle',
                  video:'EMPTY',
                  video_status:'EMPTY',
                  transcript:'EMPTY',
                  transcript_status:'EMPTY'
              };
              await this.$store.dispatch('currentShuttle', newshuttle);

          }

          //shuttleLoaded();


          this.loaded = true;
          this.shuttleLoaded = true;



      },





      crumbRoute(route_path) {
        // do nothing if null. either crumb had no route or is disabled
        if (route_path !== null) {
          //this.saveChanges();
          this.$router.push({path:route_path});
        }
      },


  },


  computed: {


    crumbs() {
      let shuttle_title = this.$store.state.currentShuttle.title;
      let crumbs_list = [{disabled:false, text:'My Shuttles', route:'/studio/list/'+this.$store.state.dynamo.customer_id}];

      crumbs_list.push({
        disabled: true,
        text: shuttle_title,
        route: null
      });


      return crumbs_list;
    },

  },

mounted() {


},

created() {


     this.checkShuttles(this.$route.params.id);
     this.$store.commit('drawerState', false);

    },

}
</script>
